import { render, staticRenderFns } from "./CsAsignacionesRutas.vue?vue&type=template&id=04bbdad5"
import script from "./CsAsignacionesRutas.vue?vue&type=script&lang=js"
export * from "./CsAsignacionesRutas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports